/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  GetPartnerServicesResponse,
  PartnerService,
  PartnerServiceBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    GetPartnerServicesResponseFromJSON,
    GetPartnerServicesResponseToJSON,
    PartnerServiceFromJSON,
    PartnerServiceToJSON,
    PartnerServiceBodyFromJSON,
    PartnerServiceBodyToJSON,
} from '../models/index';

export interface CreatePartnerServicesRequest {
    partnerServiceBody?: PartnerServiceBody;
}

export interface DeletePartnerServicesIdRequest {
    id: string;
}

export interface GetPartnerServicesSingleRequest {
    id?: string;
    utmSource?: string;
    oAuthClientId?: string;
}

export interface UpdatePartnerServicesIdRequest {
    id: string;
    partnerServiceBody?: PartnerServiceBody;
}

/**
 * PartnerServicesApi - interface
 * 
 * @export
 * @interface PartnerServicesApiInterface
 */
export interface PartnerServicesApiInterface {
    /**
     * Used by admins to create new partner service.
     * @param {PartnerServiceBody} [partnerServiceBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerServicesApiInterface
     */
    createPartnerServicesRaw(requestParameters: CreatePartnerServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerService>>;

    /**
     * Used by admins to create new partner service.
     */
    createPartnerServices(requestParameters: CreatePartnerServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerService>;

    /**
     * Used by admins to delete an existing partner service.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerServicesApiInterface
     */
    deletePartnerServicesIdRaw(requestParameters: DeletePartnerServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to delete an existing partner service.
     */
    deletePartnerServicesId(requestParameters: DeletePartnerServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to get a list of all partner services.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerServicesApiInterface
     */
    getPartnerServicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPartnerServicesResponse>>;

    /**
     * Used to get a list of all partner services.
     */
    getPartnerServices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPartnerServicesResponse>;

    /**
     * Used to query for a single partner service.
     * @param {string} [id] ID of partner service
     * @param {string} [utmSource] UTM source of partner service
     * @param {string} [oAuthClientId] OAuth client id linked to the partner service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerServicesApiInterface
     */
    getPartnerServicesSingleRaw(requestParameters: GetPartnerServicesSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerService>>;

    /**
     * Used to query for a single partner service.
     */
    getPartnerServicesSingle(requestParameters: GetPartnerServicesSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerService>;

    /**
     * Used by admins to update existing partner service.
     * @param {string} id 
     * @param {PartnerServiceBody} [partnerServiceBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerServicesApiInterface
     */
    updatePartnerServicesIdRaw(requestParameters: UpdatePartnerServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerService>>;

    /**
     * Used by admins to update existing partner service.
     */
    updatePartnerServicesId(requestParameters: UpdatePartnerServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerService>;

}

/**
 * 
 */
export class PartnerServicesApi extends runtime.BaseAPI implements PartnerServicesApiInterface {

    /**
     * Used by admins to create new partner service.
     */
    async createPartnerServicesRaw(requestParameters: CreatePartnerServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerService>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/partner-services`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerServiceBodyToJSON(requestParameters['partnerServiceBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerServiceFromJSON(jsonValue));
    }

    /**
     * Used by admins to create new partner service.
     */
    async createPartnerServices(requestParameters: CreatePartnerServicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerService> {
        const response = await this.createPartnerServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admins to delete an existing partner service.
     */
    async deletePartnerServicesIdRaw(requestParameters: DeletePartnerServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePartnerServicesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/partner-services/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to delete an existing partner service.
     */
    async deletePartnerServicesId(requestParameters: DeletePartnerServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePartnerServicesIdRaw(requestParameters, initOverrides);
    }

    /**
     * Used to get a list of all partner services.
     */
    async getPartnerServicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPartnerServicesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/partner-services`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPartnerServicesResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of all partner services.
     */
    async getPartnerServices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPartnerServicesResponse> {
        const response = await this.getPartnerServicesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Used to query for a single partner service.
     */
    async getPartnerServicesSingleRaw(requestParameters: GetPartnerServicesSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerService>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['utmSource'] != null) {
            queryParameters['utmSource'] = requestParameters['utmSource'];
        }

        if (requestParameters['oAuthClientId'] != null) {
            queryParameters['oAuthClientId'] = requestParameters['oAuthClientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner-services/single`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerServiceFromJSON(jsonValue));
    }

    /**
     * Used to query for a single partner service.
     */
    async getPartnerServicesSingle(requestParameters: GetPartnerServicesSingleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerService> {
        const response = await this.getPartnerServicesSingleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admins to update existing partner service.
     */
    async updatePartnerServicesIdRaw(requestParameters: UpdatePartnerServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerService>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePartnerServicesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/partner-services/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerServiceBodyToJSON(requestParameters['partnerServiceBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerServiceFromJSON(jsonValue));
    }

    /**
     * Used by admins to update existing partner service.
     */
    async updatePartnerServicesId(requestParameters: UpdatePartnerServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerService> {
        const response = await this.updatePartnerServicesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
